import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';

import Modal from '@/ui/Modal/Modal';
import Button from '@/ui/Button/Button';
import { RedSuccess } from '@/components/SvgComponents/RedSuccess';

import styles from './SuccessModal.module.scss';

export const SuccessModal = ({
  active,
  setSuccessModal = () => null,
  title,
  description,
  buttonTxt,
  buttonVariant,
  href,
}) => {
  const { t } = useTranslation();
  const router = useRouter();
  const clickHandler = () => {
    setSuccessModal(false);
    if (buttonVariant === 'Router') {
      router.push(href);
    }
  };
  return (
    <Modal
      className={styles.modalCustom}
      active={active}
      setActive={() => setSuccessModal(false)}
      itemScope
      itemType='https://schema.org/Property'
    >
      <div className={styles.successModal}>
        <RedSuccess />
        <h2>{title || t('cabinet:common.Success')}</h2>
        <p>{description || t('cabinet:common.TariffSuccess')}</p>
        <div className={styles.successModal__buttons}>
          <div className={styles.successModal__innerDiv}>
            <Button onClick={() => clickHandler()}>
              {buttonTxt || t('common:Ok')}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
